import type {
  IBillingProfileDataWeb,
  IBillingProfileData,
  IUpdateBillingProfileBody,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

/** Update the billing profile associated with a customer in BillingPlatform. */
export const updateBillingProfile = async ({
  billingProfile,
}: {
  billingProfile: IBillingProfileData;
}): Promise<IBillingProfileDataWeb> => {
  const { data } = await axios.post<
    IBillingProfileDataWeb,
    AxiosResponse<IBillingProfileDataWeb>,
    IUpdateBillingProfileBody
  >('/billing/billing_profile/', { billingProfile });
  return data;
};
